document.addEventListener('turbolinks:load', function () {
    if ($('#new-plan-review-form').length === 0) {
        return false
    }

    processStep();

    function processStep() {
        $('.previous-step-btn, .next-step-btn, #plan-review-form-tab .form-tab').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            submitForm(targetId)
            window.scrollTo(0, 0)
        });
    }

    function submitForm(targetId) {
        assignFormValue(targetId)
        submitPlanReviewForm()
    }

    function assignFormValue(targetId) {
        $('#next_tab_id').val(targetId);
        // $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
    }

    function submitPlanReviewForm() {
        let form = document.querySelector('#plan-review-form');

        // Add submit event listener to show loader only when form is actually submitted
        form.addEventListener('submit', function() {
            showLoader();
        });

        let button = document.createElement('input');
        button.style.display = 'none';
        button.type = 'submit';
        form.appendChild(button).click();
        form.removeChild(button);
    }

    function showLoader() {
        $('.loading-spinner').show();
        $('body').css({
            pointerEvents: "none"
        })
    }
});